import React, { Component } from "react";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { a11yDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import remarkGfm from "remark-gfm";
import _ from "lodash";
import { Box } from "@mui/system";
import {
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";

class Markdowner extends Component {
  renderRow = (obj) => {
    if (!obj || !obj.props || !obj.props.children) {
      return null;
    }
    let children = obj.props.children;
    return (
      <TableRow>
        {children.map((child, childIndex) => {
          if (!child || !child.props || !child.props.children) {
            return <TableCell></TableCell>;
          }
          let c = child.props.children[0];
          return <TableCell key={childIndex}>{c}</TableCell>;
        })}
      </TableRow>
    );
  };
  renderers = {
    h1: ({ children, ...props }) => {
      return (
        <Box>
          <Typography variant="subtitle1">{children}</Typography>
        </Box>
      );
    },
    h2: ({ children, ...props }) => {
      return (
        <Box
          sx={{
            mt: 1,
          }}
        >
          <Chip label={children} size="medium" color="warning" />
        </Box>
      );
    },
    h3: ({ children, ...props }) => {
      return (
        <Box
          sx={{
            mt: 1,
          }}
        >
          <Chip label={children} size="small" color="info" />
        </Box>
      );
    },
    table: ({ children, ...props }) => {
      let headerRows = _.filter(children, (x) => x && x.type === "thead");
      let bodyRows = _.filter(children, (x) => x && x.type === "tbody");
      return (
        <TableContainer>
          <Table size="small">
            <TableHead>
              {headerRows.map((hr, hrIndex) => {
                let c = hr.props.children;
                return (
                  c &&
                  c.map((row, rowIndex) => {
                    return this.renderRow(row);
                  })
                );
              })}
            </TableHead>
            <TableBody>
              {bodyRows.map((br, brIndex) => {
                let c = br.props.children;

                return (
                  c &&
                  c.map((row, rowIndex) => {
                    return this.renderRow(row);
                  })
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    },

    strong: ({ children, ...props }) => {
      return <Typography variant="overline">{children}</Typography>;
    },
    a: ({ children, href, ...props }) => {
      if (this.props.isAsst) {
        if (this.props.annotations && this.props.annotations.length) {
          let annotationSandboxLink = props.node.properties.href;
          let correctAnnotation = _.find(
            this.props.annotations,
            (x) => x.text === annotationSandboxLink
          );

          if (correctAnnotation) {
            let apiUrl = process.env.REACT_APP_API_URL;
            let fileUrl = `${apiUrl}/harley/GeneratedFile/${correctAnnotation.file_path.file_id}`;
            return (
              <Button
                href={fileUrl}
                // target="_blank"
                variant="outlined"
                size="small"
                color="primary"
                download
              >
                {children}
              </Button>
            );
          } else {
            return null;
          }
        }
      } else {
        return (
          <Button
            href={href}
            target="_blank"
            variant="outlined"
            size="small"
            color="primary"
          >
            {children}
          </Button>
        );
      }
    },
    code: ({ children, inline, ...props }) => {
      if (inline) {
        return <code>{children}</code>;
      }
      let cc;
      if (typeof children === "string") {
        cc = children;
      } else {
        cc = children.map((x) => _.trimEnd(x, "\n")).filter(Boolean);
        if (!cc || cc.length === 0) cc = [""];
        if (cc[0].startsWith("\n")) {
          cc[0] = cc[0].substring(1);
        }
      }
      return (
        <SyntaxHighlighter
          style={a11yDark}
          language={"python"}
          showLineNumbers={true}
          wrapLongLines={true}
          customStyle={{
            fontSize: "small",
          }}
        >
          {cc}
        </SyntaxHighlighter>
      );
    },
  };

  render() {
    return (
      <div
        style={{
          fontSize: "small",
        }}
      >
        <ReactMarkdown
          children={this.props.text}
          components={this.renderers}
          remarkPlugins={[remarkGfm, remarkMath]} // Include remarkMath here
          rehypePlugins={[rehypeKatex]} // Include rehypeKatex here
        />
      </div>
    );
  }
}

export default Markdowner;
